<template>
    <div class="wrap">
        <h3>{{$t('validate.resetPasswordDetails')}}</h3>
        <div class="input">
            <span>{{$t('register.password')}}</span>
            <div class="item">
                <input :type="visible ? 'text' : 'password'"
                 v-model="password"
                 @focus="passwordError = false"
                 :placeholder="$t('register.passwordPlaceholder')"
                 :class="{error: passwordError}"
                 @keydown.enter="login"
                >
                <div class="reveal-password" @click="handlePassword(!visible)">
                    <span class="material-icons">
                        {{visible ? 'visibility_off' : 'visibility'}}
                    </span>
                </div>
            </div>
            <small v-if="passwordError">{{$t('register.passwordError')}}</small>
        </div>
        <div class="input">
            <span>{{$t('register.confirmPassword')}}</span>
            <div class="item">
                <input :type="confirmVisible ? 'text' : 'password'"
                 :class="{error: confirmPasswordError}"
                 v-model="confirmPassword"
                 @focus="confirmPasswordError = false"
                 :placeholder="$t('register.confirmPasswordPlaceholder')"
                 @keydown.enter="login"
                >
                <div class="reveal-password" @click="handleConfirmPassword(!confirmVisible)">
                    <span class="material-icons">
                        {{confirmVisible ? 'visibility_off' : 'visibility'}}
                    </span>
                </div>
            </div>
            <small v-if="confirmPasswordError">{{$t('register.confirmPasswordError')}}</small>
        </div>
        <div class="button-wrap">
            <div class="button-round" @click="login">{{$t('button.finish')}} &nbsp;<span class="material-icons">arrow_right_alt</span></div>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            password: '',
            confirmPassword: '',
            visible: false,
            passwordError: false,
            confirmPasswordError: false,
            confirmVisible: false
        }
    },
    methods: {
        login () {
            const passwordCheck = this.password.length >= 8
            const confirmPasswordCheck = this.password === this.confirmPassword
            if (!passwordCheck) {
                this.passwordError = true
            }
            if (!confirmPasswordCheck) {
                this.confirmPasswordError = true
            }
            if (!passwordCheck || !confirmPasswordCheck) {
                return
            }
            this.$emit('next-password', { password:this.password })
        },
        handlePassword (val) {
            this.visible = val
        },
        handleConfirmPassword (val) {
            this.confirmVisible = val
        }
    }
}
</script>

<style scoped lang="scss">
h3 {
    margin-bottom: 40px;
}
.button-wrap {
    margin: 30px 0 0 0;
    display: flex;
    justify-content: flex-end;
}
.button-round {
    background: var(--button-color-yellow);
}
.item {
        position: relative
    }
.input {
    margin: 15px 0;
    span {
        margin-bottom: 3px;
    }
    small {
        color: red;
    }
    input {
        border: 1.5px solid transparent;
        transition: border-color .2s ease;
        &.error {
            border-color: red;
        }
    }
}
.reveal-password {
    position: absolute;
    display: inline;
    top: 55%;
    transform: translateY(-50%);
    right: 6px;
    cursor: pointer;
    user-select: none;
    opacity: .5;
}
</style>